import React, { useEffect, useState } from "react";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { DB_POSTFIX } from "../../../utils";

const AnnouncementBar = () => {
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?sadb=" +
          DB_POSTFIX +
          "&type=announcement&upcoming=1&top_scroll=1"
      )
      .then((res) => {
        if (res.data.status === "1") {
          setDataList(res.data.data);
        }
        setLoader(false);
      });
  };

  return (
    <div className="announcement-bar">
      <div className="announcement-label">Latest Announcements</div>
      <div className="announcement-content">
        <marquee behavior="scroll" direction="left" scrollamount="4">
          {dataList.length > 0 ? (
            dataList.map((item, index) => (
              <span key={index} className="announcement-item">
                {item.title}
              </span>
            ))
          ) : (
            <span>No announcements available</span>
          )}
        </marquee>
      </div>
    </div>
  );
};

export default AnnouncementBar;
